import { applyMiddleware, createStore, compose } from 'redux';
import thunk from 'redux-thunk';
import { routerMiddleware } from 'connected-react-router';
import rootReducer from './rootReducer';

const enableReduxLog = true;

export default (initialState, history) => {
  const middlewares = [thunk, routerMiddleware(history)].filter(Boolean);
  let composeEnhancers = compose;

  if (process.env.NODE_ENV === 'development' && enableReduxLog) {
    composeEnhancers =
      typeof window === 'object' && window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__
        ? window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__({})
        : compose;
  }

  const store = compose(
    createStore(
      rootReducer(history),
      initialState,
      composeEnhancers(applyMiddleware(...middlewares))
    )
  );

  return store;
};
